// test2220
(2220 && 0);
